import { Modals } from '@lib/enums/modals';
import { UseModalManagementResult } from '@lib/hooks/useModalManagement';
import { TabBarItem as TabBarItemType } from '@lib/components/TabBar/constants';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import { Values } from '@lib/interfaces/form';
import getFilterFieldNameByMonitoringEntity from 'routes/Dashboard/Monitoring/utils/getFilterFieldNameByMonitoringEntity';
import getLegendFilterName from 'routes/Dashboard/Monitoring/utils/getLegendFilterName';
import { MonitoringEntity, MonitoringType } from '../enums';

export default function useMonitoringMapActions({
  useModalManagementResult,
  setMonitoringType,
  setShowSitesOnSectors,
  onUpdateFilterParams,
  monitoringEntity,
  monitoringType,
  statusKind,
}: {
  useModalManagementResult: UseModalManagementResult;
  setMonitoringType: (v: MonitoringType) => void;
  setShowSitesOnSectors: React.Dispatch<React.SetStateAction<boolean>>;
  onUpdateFilterParams: (values: Values) => void;
  monitoringEntity: MonitoringEntity;
  monitoringType: MonitoringType;
  statusKind?: any;
}) {
  const { openModal, closeModal } = useModalManagementResult;

  const onLegendFormModalOpen = () => openModal(Modals.LegendFormModal);
  const onLegendFormModalClose = () => closeModal(Modals.LegendFormModal);

  const onTabChange = (item?: TabBarItemType) => {
    if (item?.value) setMonitoringType(item.value as MonitoringType);
  };

  const onToggleShowSitesOnSectors = () => {
    setShowSitesOnSectors((prev) => !prev);
  };

  const onLegendUpdate = (values: Values) => {
    const legendName = getLegendFilterName(
      monitoringEntity,
      monitoringType,
      statusKind,
    );
    onUpdateFilterParams({
      [getFilterFieldNameByMonitoringEntity(
        monitoringEntity,
        MonitoringFilterFieldNames.FilterPresetId,
      )]: undefined,
      [legendName]: values,
    });
    onLegendFormModalClose();
  };

  return {
    onLegendFormModalOpen,
    onLegendFormModalClose,
    onTabChange,
    onToggleShowSitesOnSectors,
    onLegendUpdate,
  };
}
